export { Title } from './Title'
export type { TitleProps } from './Title.types'
